import { Input, InputNumber } from "antd";
import {
  InputNumberProps,
  InputProps,
  OTPInputProps,
  PasswordProps,
  SearchProps,
  TextAreaProps,
} from "./type";
const { Password, TextArea, Search } = Input;
function AntInput(props: InputProps) {
  return <Input {...props} />;
}
function AntInputNumber(props: InputNumberProps) {
  return <InputNumber {...props} />;
}
function AntTextArea(props: TextAreaProps) {
  return <TextArea {...props} />;
}
function AntPassword(props: PasswordProps) {
  return <Password {...props} />;
}
function AntSearch(props: SearchProps) {
  return <Search {...props} />;
}

function OptInput(props: OTPInputProps) {
  return <OptInput {...props} />;
}
export {
  AntInput as Input,
  AntInputNumber as InputNumber,
  AntTextArea as TextArea,
  AntPassword as Password,
  AntSearch as Search,
  OptInput,
};
